import { Injectable } from "@angular/core";
import { UsuarioMarcacoesService } from "./usuario.marcacoes.service";
import { UsuarioComentariosService } from "./usuario.comentarios.service";
import { UsuarioGrifosService } from "./usuario.grifos.service";
import {
  MarcacaoServiceCarregarMarcacaoResult,
  MarcacaoServiceCarregarAnotacaoResult,
} from "../../models/MarcacaoServiceCarregarMarcacaoResult";
import { UsuarioApontamentosService } from "./usuario.apontamentos.service";

@Injectable()
export class UsuarioAnotacoesService {
  constructor(
    private usuarioMarcacoesService: UsuarioMarcacoesService,
    private usuarioComentariosService: UsuarioComentariosService,
    private usuarioGrifosService: UsuarioGrifosService,
    private usuarioApontamentosService: UsuarioApontamentosService
  ) {}

  public buscarAnotacoes(
    idItem: string = null,
    versao: number = null
  ): Promise<MarcacaoServiceCarregarMarcacaoResult> {
    const result = new MarcacaoServiceCarregarMarcacaoResult();
    result.idItem = idItem;

    const promises = new Array<Promise<any>>();

    promises.push(
      this.usuarioMarcacoesService
        .buscarLinhaVersao(idItem, versao)
        .then((marcacoes) => {
          result.marcacoes = marcacoes;
        })
    );

    promises.push(
      this.usuarioComentariosService
        .buscarLinhaVersao(idItem, versao)
        .then((comentarios) => {
          result.comentarios = comentarios;
        })
    );

    promises.push(
      this.usuarioGrifosService.buscarLinha(idItem, versao).then((grifos) => {
        result.grifos = grifos;
      })
    );

    return Promise.all(promises).then(() => result);
  }

  public buscarAnotacoesPorLei(
    idLei: string
  ): Promise<MarcacaoServiceCarregarMarcacaoResult> {
    const result = new MarcacaoServiceCarregarMarcacaoResult();
    result.idLei = idLei;

    const promises = new Array<Promise<any>>();

    promises.push(
      this.usuarioMarcacoesService
        .buscarLei(idLei)
        .then((marcacoes) => (result.marcacoes = marcacoes))
    );
    promises.push(
      this.usuarioComentariosService
        .buscarLei(idLei)
        .then((comentarios) => (result.comentarios = comentarios))
    );
    promises.push(
      this.usuarioGrifosService
        .buscarLei(idLei)
        .then((grifos) => (result.grifos = grifos))
    );

    return Promise.all(promises).then(() => result);
  }

  public buscarAnotacoesApontamentosPorLei(
    idLei: string
  ): Promise<MarcacaoServiceCarregarAnotacaoResult> {
    const result = new MarcacaoServiceCarregarAnotacaoResult();
    result.idLei = idLei;

    const promises = new Array<Promise<any>>();

    promises.push(
      this.usuarioMarcacoesService
        .buscarLei(idLei)
        .then((marcacoes) => (result.marcacoes = marcacoes))
    );
    promises.push(
      this.usuarioComentariosService
        .buscarLei(idLei)
        .then((comentarios) => (result.comentarios = comentarios))
    );
    promises.push(
      this.usuarioGrifosService
        .buscarLei(idLei)
        .then((grifos) => (result.grifos = grifos))
    );
    promises.push(
      this.usuarioApontamentosService
        .buscarId(idLei)
        .then((apontamentos) => (result.apontamentos = apontamentos))
    );

    return Promise.all(promises).then(() => result);
  }
}
